import { createSelector } from 'reselect'

import { selectCommitmentState } from './selectCommitmentState'

export const selectCommitmentStatusesLoadingStatus = createSelector(
  [selectCommitmentState],
  (state) => state.commitmentStatuses.status
)
